import { FC } from 'react'
import { useGetProcessOptions } from 'framework/api/methods'

import {
  PartnerFilterDropdown,
  PartnerFilterOption,
} from './PartnerFilterDropdown'

export const ALL_PROCESSES = ''

export interface EmailAlertsFilterBarProps {
  selectedPartner: PartnerFilterOption
  onPartnerChange: (option: PartnerFilterOption) => void
  selectedProcess: string
  onProcessChange: (process: string) => void
  searchInput: string
  onSearchChange: (value: string) => void
  onSearchClear: () => void
}

export const EmailAlertsFilterBar: FC<EmailAlertsFilterBarProps> = ({
  selectedPartner,
  onPartnerChange,
  selectedProcess,
  onProcessChange,
  searchInput,
  onSearchChange,
  onSearchClear,
}: EmailAlertsFilterBarProps) => {
  const { data: processOptionsData } = useGetProcessOptions()
  const processOptions: string[] = processOptionsData?.processOptions ?? []

  return (
    <div className='flex gap-4 items-end flex-wrap mt-5'>
      <PartnerFilterDropdown
        value={selectedPartner}
        onChange={onPartnerChange}
      />

      <div className='w-[210px]'>
        <div className='text-[11.5px] font-bold text-N-500 tracking-wide mb-[6px]'>
          PROCESS
        </div>
        <select
          value={selectedProcess}
          onChange={(e) => onProcessChange(e.target.value)}
          className='w-full box-border px-3 py-[10px] border border-N-300 rounded-md text-[13.5px] text-N-800 bg-white cursor-pointer outline-none h-[41px]'>
          <option value={ALL_PROCESSES}>All processes</option>
          {processOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <div className='ml-auto w-[320px]'>
        <div className='text-[11.5px] font-bold text-N-500 tracking-wide mb-[6px]'>
          SEARCH
        </div>
        <div className='relative'>
          <i className='ri-search-2-line absolute left-3 top-1/2 -translate-y-1/2 text-N-400 text-[15px]'></i>
          <input
            value={searchInput}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder='Partner name or email address…'
            className='w-full box-border pl-[38px] pr-[34px] py-[10px] border border-N-300 rounded-md text-[13.5px] outline-none text-N-800 focus:border-P-500'
          />
          {searchInput && (
            <button
              type='button'
              onClick={onSearchClear}
              className='absolute right-2 top-1/2 -translate-y-1/2 w-[22px] h-[22px] flex items-center justify-center rounded-full bg-N-100 text-N-600'>
              <i className='ri-close-line text-[12px]'></i>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default EmailAlertsFilterBar
